import { RefObject } from 'react'

import FactorNode from './FactorNode'
import { FactorBranch } from './factorTree.types'

interface Props {
  branch: FactorBranch[]
  openNode: (nodeIndices: number, nodeCompoundNumber: number, direction: 'left' | 'right') => void
  questionNumber: number | string
  difficultyLevel: number
  primarySelectedInputRef?: RefObject<HTMLInputElement>
}

const BRANCH_SPACE_BY_DL: Record<number, Record<string, { w?: number; sb: number }>> = {
  1: {
    l1: { w: 0, sb: 50 },
    l2: { w: 0, sb: 0 },
    l3: { w: 0, sb: 0 },
  },
  2: {
    l1: { w: 0, sb: 70 },
    l2: { w: 20, sb: 25 },
    l3: { w: 0, sb: 0 },
  },
  3: {
    l1: { w: 0, sb: 110 },
    l2: { w: 45, sb: 40 },
    l3: { w: 4, sb: 5 },
  },
  4: {
    l1: { w: 0, sb: 120 },
    l2: { w: 45, sb: 45 },
    l3: { w: 4, sb: 5 },
  },
}

const Tree = ({
  branch,
  openNode,
  questionNumber,
  difficultyLevel,
  primarySelectedInputRef,
}: Props): React.ReactElement => {
  const spaceConfig = BRANCH_SPACE_BY_DL[difficultyLevel]
  return (
    <div className="w-full space-y-1">
      <div className="flex items-center justify-center flex-col">
        <p className="text-purple font-semibold text-lg text-center">{questionNumber}</p>
        <FactorNode
          onNewNode={openNode}
          {...branch[0]}
          arrowLeftStyle={
            difficultyLevel >= 3 ? { height: 70, marginRight: -30, transform: 'rotate(30deg)' } : undefined
          }
          arrowRightStyle={
            difficultyLevel >= 3 ? { height: 70, marginLeft: -30, transform: 'rotate(330deg)' } : undefined
          }
          branchIndices={0}
          leftInputRef={primarySelectedInputRef}
          spaceBetween={spaceConfig.l1.sb}
        />
      </div>
      <div className="flex items-center justify-center">
        <FactorNode onNewNode={openNode} {...branch[1]} branchIndices={1} spaceBetween={spaceConfig.l2.sb} />
        <div style={{ width: spaceConfig.l2.w }} />
        <FactorNode onNewNode={openNode} {...branch[2]} branchIndices={2} spaceBetween={spaceConfig.l2.sb} />
      </div>
      <div className={`items-center justify-center ${difficultyLevel >= 3 ? 'flex' : 'hidden'}`}>
        <FactorNode onNewNode={openNode} {...branch[3]} branchIndices={3} spaceBetween={spaceConfig.l3.sb} />
        <div style={{ width: spaceConfig.l3.w }} />
        <FactorNode onNewNode={openNode} {...branch[4]} branchIndices={4} spaceBetween={spaceConfig.l3.sb} />
        <div style={{ width: spaceConfig.l3.w }} />
        <FactorNode onNewNode={openNode} {...branch[5]} branchIndices={5} spaceBetween={spaceConfig.l3.sb} />
        <div style={{ width: spaceConfig.l3.w }} />
        <FactorNode onNewNode={openNode} {...branch[6]} branchIndices={6} spaceBetween={spaceConfig.l3.sb} />
      </div>
      <div className={`items-center justify-center ${difficultyLevel === 4 ? 'flex' : 'hidden'}`}>
        <FactorNode
          onNewNode={openNode}
          {...branch[7]}
          branchIndices={7}
          className="relative"
          spaceBetween={5}
          style={{ left: 104 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[8]}
          branchIndices={8}
          className="relative"
          spaceBetween={5}
          style={{ left: 75 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[9]}
          branchIndices={9}
          className="relative"
          spaceBetween={5}
          style={{ left: 46 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[10]}
          branchIndices={10}
          className="relative"
          spaceBetween={5}
          style={{ left: 15 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[11]}
          branchIndices={11}
          className="relative"
          spaceBetween={5}
          style={{ left: -15 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[12]}
          branchIndices={12}
          className="relative"
          spaceBetween={5}
          style={{ left: -46 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[13]}
          branchIndices={13}
          className="relative"
          spaceBetween={5}
          style={{ left: -75 }}
        />
        <FactorNode
          onNewNode={openNode}
          {...branch[14]}
          branchIndices={14}
          className="relative"
          spaceBetween={5}
          style={{ left: -104 }}
        />
      </div>
    </div>
  )
}

export default Tree
